import React, { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import "src/styles/idol_page.css"
import { idolData } from "public/data/idols/idols";
import { Link } from "react-router-dom";
import { PageTitle } from "src/components/pageTitle";
import { IdolFace } from "src/components/spriteWrappers";

export function IdolPage(props){
	const slug = useParams().slug;
	return (<IdolPageView 
		data={idolData[slug]}
	/>)
}

function IdolPageView(props){
	
    const renderRef = useRef<HTMLImageElement>(null);
    const textWrapperRef = useRef<HTMLDivElement>(null);

    const SHOW_ANIMATED_SPRITE = true;

    const updateTextWrapper = () => {
        if (renderRef.current && textWrapperRef.current) {
            const render = renderRef.current;
            const textWrapper = textWrapperRef.current;
            textWrapper.style.height = `${render.offsetHeight}px`;
            textWrapper.style.width = `${render.offsetWidth}px`;
            setRenderPosition();
        }
    };

    const setRenderPosition = () => {
        const render = renderRef.current;
        const textWrapper = textWrapperRef.current;
        const description = document.getElementsByClassName("idol-description-text")[0];

        if (description) {
            const top = -(description.getBoundingClientRect().top - render.getBoundingClientRect().top);
            const left = render.getBoundingClientRect().right - description.getBoundingClientRect().right;

            textWrapper.style.top = `${top}px`;
            textWrapper.style.left = `${left}px`;
        }
    };

    useEffect(() => {
        const handleResize = () => {
            updateTextWrapper();
        };

        window.addEventListener("resize", handleResize);
        renderRef.current.addEventListener("load", () => {
            updateTextWrapper();
        })
        
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <>
        <PageTitle pageTitle={props.data.slug !== "aqua" ? `${props.data.firstName} ${props.data.lastName}` : "Aqua"}/>
        <div id="main" className="main-idol hide-footer" style={{
            "--clr_main": `var(--${props.data.slug}_main)`,
            "--clr_secondary": `var(--${props.data.slug}_secondary)`,
            "--clr_strong": `var(--${props.data.slug}_strong)`,
            "--clr_light": `var(--${props.data.slug}_light)`,
            "--clr_soft": `var(--${props.data.slug}_soft)`,
            "--icon_index": props.data.logos.iconIndex,
            "--text_logo_offset": props.data.logos.textLogoOffset
        }}>
            <div className="bg-circle transition-color"/>
            <div className="bg-container transition-color"/>

            <div className="idol-logo-text-wrapper">
                <div 
                    className="idol-logo-text"
                    src="/images/idols/logo_main771.ss.png"
                    alt="Idol Logo"
                />
            </div>

            <IdolInformation 
				firstName={props.data.firstName}
				lastName={props.data.lastName}
				age={props.data.age}
				birthday={props.data.birthday}
				flower={props.data.flower}
				colorName={props.data.colorName}
				placeOfBirth={props.data.placeOfBirth}
			/>

            <div className="quote-box transition-color">
                <p className="quote">{props.data.quote}</p>
            </div>

            <p className="about idol-slide-in-lr">About</p>
            <section className="idol-description">
                {/* <div
                    id="text-wrapper"
                    ref={textWrapperRef}
                    // style={{
                    //     "--idol-url": `url(/images/idols/${props.data.slug}/render.png)`
                    // }}
                /> */}
                <p 
                className="idol-description-text idol-slide-in-lr" 
                dangerouslySetInnerHTML={{__html: props.data.description}}
                style={{"--extra-delay": "100ms"}}
                />
                <p className="cv transition-color idol-slide-in-lr" style={{"--extra-delay": "200ms"}}>CV: {props.data.va}</p>
            </section>

            <div className="bg-lines-1">
                    <div className="lines"/>
            </div>

            <div className="backdrop-idol transition-color">
                <p id="text-rotate" className="unselectable">
                    
                    <b>
                    {props.data.slug !== "aqua" ? <>{props.data.lastName}<br />{props.data.firstName}</> : <span className="why-does-aqua-have-to-be-so-quirky">Aqua</span>}
                    </b>
                    <br />
                    <b id="hacky-idiot-solution" aria-hidden="true">.</b>
                </p>
            </div>

            {SHOW_ANIMATED_SPRITE ? 
            <video id="idol-render"
            alt="Idol Render" autoPlay={true} muted={true} loop={true}
            style={{
                width: "calc(5000px / 9)",
                height: "925px",
                objectFit: "cover",
                objectPosition: `right calc(5000px / 9 * ${props.data.videoCrop.index} + ${props.data.videoCrop.pixelOffset}px) top 50%`
            }}
            src={`/images/idols/grid3.webm`}
            ref={renderRef}/> 
            : 
            <img
            id="idol-render"
            alt="Idol Render"
            src={`/images/idols/${props.data.slug}/render.png`}
            style={{"--idol-url": `url(/images/idols/${props.data.slug}/render.png)`}}
            ref={renderRef}
            />}

            

			<div id="idol-nav">
				{idolData.order.map(idol => {
					return <div className="idol-button-wrapper"><Link
					key={idol}
					className="idol-button"
					to={`/idols/${idol}`}
					id={idol === props.data.slug ? "current" : undefined}
                    style={{"--color-main":`var(--${idol}_strong)`, "--color-soft":`var(--${idol}_soft)`}}
                    >
                        <IdolFace slug={idol}/>
						{/* <img 
						className="idol-button-image" 
						src={`/images/idols/${idol}/face_small.png`} 
						/> */}
					</Link></div>
				})}
			</div>
        </div>
        </>
    );
};

interface IdolInformationProps {
    firstName: string;
    lastName: string;
    age: number;
    birthday: string;
    flower: string;
    colorName: string;
    placeOfBirth: string;
}

function IdolInformation(props: IdolInformationProps){
    return (
        <div id="idol-information" className="transition-color">
            <p className="info">
                First name<br />
                <b className={`value${props.firstName == "[redacted]" ? " redacted" : ""}`}>{props.firstName}</b>
            </p>

            <p className="info">
                Last name<br />
                <b className={`value${props.firstName == "[redacted]" ? " redacted" : ""}`}>{props.lastName}</b>
            </p>

            <p className="info">
                Age<br />
                <b className="value">{props.age}</b>
            </p>

            <p className="info">
                Birthday<br />
                <b className="value">{props.birthday}</b>
            </p>

            <p className="info">
                Flower<br />
                <b className="value">{props.flower}</b>
            </p>

            <p className="info">
                Color<br />
                <b className="value">{props.colorName}</b>
            </p>

            <p className="info">
                Place of birth<br />
                <b className="value">{props.placeOfBirth}</b>
            </p>
        </div>
    );
};

